import { styled } from '../../styled';
export var AppBarContentComponentName = 'QuantumAppBarContent';
export var AppBarContent = styled('div', {
    name: AppBarContentComponentName,
    slot: 'Root',
})(function (_a) {
    var theme = _a.theme;
    return ({
        display: 'flex',
        alignItems: 'center',
        height: '100%',
        maxWidth: '100%',
        padding: theme.spacing(0, 2),
    });
});
